import React from "react";

/**
 * Card de parametrização de horário de uso (seg–sex, sáb, dom).
 */
export default function MovementConfigCard({
  movementForm,
  onMovementFormChange,
}) {
  return (
    <div className="card col-md-12 p-3 mt-3">
      <h5 className="mb-3">Parametrização de horário de uso</h5>

      {/* Segunda a Sexta */}
      <div className="row align-items-center g-2 mb-2">
        <div className="col-auto">
          <div className="form-check form-switch">
            <label className="form-check-label">De Segunda a Sexta</label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={movementForm.weekdays.flag}
              onChange={(e) =>
                onMovementFormChange((prev) => ({
                  ...prev,
                  weekdays: { ...prev.weekdays, flag: e.target.checked },
                }))
              }
            />
          </div>
        </div>

        <div className="col-auto" style={{ marginTop: 5.5, marginLeft: 30 }}>
          <label className="form-check-label">De:</label>
        </div>
        <div className="col-auto d-flex">
          <input
            type="time"
            className="form-control form-control-sm"
            value={movementForm.weekdays.start}
            max={movementForm.weekdays.end}
            onChange={(e) =>
              onMovementFormChange((prev) => ({
                ...prev,
                weekdays: { ...prev.weekdays, start: e.target.value },
              }))
            }
          />
          <label className="form-check-label" style={{ margin: "0 10px" }}>
            Até:
          </label>
          <input
            type="time"
            className="form-control form-control-sm"
            value={movementForm.weekdays.end}
            min={movementForm.weekdays.start}
            onChange={(e) =>
              onMovementFormChange((prev) => ({
                ...prev,
                weekdays: { ...prev.weekdays, end: e.target.value },
              }))
            }
          />
        </div>
      </div>

      {/* Sábado */}
      <div className="row align-items-center g-2 mb-2">
        <div className="col-auto">
          <div className="form-check form-switch">
            <label className="form-check-label">Sábado</label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={movementForm.saturday.flag}
              onChange={(e) =>
                onMovementFormChange((prev) => ({
                  ...prev,
                  saturday: { ...prev.saturday, flag: e.target.checked },
                }))
              }
            />
          </div>
        </div>

        <div className="col-auto" style={{ marginTop: 5.5, marginLeft: 30 }}>
          <label className="form-check-label">De:</label>
        </div>
        <div className="col-auto d-flex">
          <input
            type="time"
            className="form-control form-control-sm"
            value={movementForm.saturday.start}
            max={movementForm.saturday.end}
            onChange={(e) =>
              onMovementFormChange((prev) => ({
                ...prev,
                saturday: { ...prev.saturday, start: e.target.value },
              }))
            }
          />
          <label className="form-check-label" style={{ margin: "0 10px" }}>
            Até:
          </label>
          <input
            type="time"
            className="form-control form-control-sm"
            value={movementForm.saturday.end}
            min={movementForm.saturday.start}
            onChange={(e) =>
              onMovementFormChange((prev) => ({
                ...prev,
                saturday: { ...prev.saturday, end: e.target.value },
              }))
            }
          />
        </div>
      </div>

      {/* Domingo */}
      <div className="row align-items-center g-2 mb-2">
        <div className="col-auto">
          <div className="form-check form-switch">
            <label className="form-check-label">Domingo</label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={movementForm.sunday.flag}
              onChange={(e) =>
                onMovementFormChange((prev) => ({
                  ...prev,
                  sunday: { ...prev.sunday, flag: e.target.checked },
                }))
              }
            />
          </div>
        </div>

        <div className="col-auto" style={{ marginTop: 5.5, marginLeft: 30 }}>
          <label className="form-check-label">De:</label>
        </div>
        <div className="col-auto d-flex">
          <input
            type="time"
            className="form-control form-control-sm"
            value={movementForm.sunday.start}
            max={movementForm.sunday.end}
            onChange={(e) =>
              onMovementFormChange((prev) => ({
                ...prev,
                sunday: { ...prev.sunday, start: e.target.value },
              }))
            }
          />
          <label className="form-check-label" style={{ margin: "0 10px" }}>
            Até:
          </label>
          <input
            type="time"
            className="form-control form-control-sm"
            value={movementForm.sunday.end}
            min={movementForm.sunday.start}
            onChange={(e) =>
              onMovementFormChange((prev) => ({
                ...prev,
                sunday: { ...prev.sunday, end: e.target.value },
              }))
            }
          />
        </div>
      </div>
    </div>
  );
}
